import Image from '../image';
import React from 'react';

class Promo extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { promo } = this.props.data;

        const image = (
            <Image
                data={ promo.image }
                title={ promo.title }
            />
        );

        let content;

        if (promo.link) {
            content = (
                <a href={ promo.link }>
                    { image }
                </a>
            );
        } else {
            content = image;
        }

        return (
            <div className={ this.props.className }>
                { content }
            </div>
        );
    }
}


export default Promo;



// WEBPACK FOOTER //
// ./src/client/components/promo/index.js